export default __webpack_public_path__ + "static/media/quiz-bg.4649634a.png";